import { createFileRoute } from "@tanstack/react-router";
import { TenantsScreen, validateTenantsSearch } from "../-tenants/TenantsScreen";

export const Route = createFileRoute("/admin/tenants/")({
  staticData: { title: "Tenants" },
  validateSearch: validateTenantsSearch,
  component: TenantsScreen,
});
